import React from 'react';
import styled from 'styled-components';
import BackIcon from '../../images/ui/chevron-circle-left-light.svg';

const BackBtn = styled.div`
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 60px;
  position: absolute;
  z-index: 9000;
  cursor: pointer;
  top: 8px;
  right: 8px;
`;
const BackText = styled.span`
  font-size: 12px;
  margin-right: 8px;
`;
const BackImg = styled.img`
  height: 24px;
  width: 24px;
`;

export default function BackButton(props) {
  return (
    <BackBtn onClick={props.close} id={props.id}>
      {props.noText ? '' : <BackText>BACK</BackText>}{' '}
      {<BackImg src={BackIcon} alt="Back" />}
    </BackBtn>
  );
}
